var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"logout",attrs:{"title":"Odhlášení"},on:{"click":_vm.logout}},[_vm._v("Odhlášení")])])}
var staticRenderFns = []

export { render, staticRenderFns }